import type { Film } from '@/types/film';

export const films: Film[] = [
  {
    id: 'night-tide',
    title: '夜潮',
    type: 'movie',
    genre: '悬疑',
    region: '中国大陆',
    year: 2025,
    episodes: '128 分钟',
    rating: 8.7,
    views: 1284000,
    updatedAt: '2025-09-28',
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20lone%20silhouette%20standing%20on%20a%20rain-soaked%20harbor%20pier%20at%20night%2C%20deep%20navy%20blue%20tones%20with%20glowing%20amber%20streetlight%20reflections%20on%20wet%20stone%2C%20moody%20atmospheric%20fog%2C%20minimalist%20modern%20poster%20layout%2C%20dramatic%20high%20contrast%2C%20no%20text&width=600&height=900&seq=v91-poster-night-tide&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20harbor%20scene%20with%20lone%20figure%20on%20wet%20pier%2C%20deep%20navy%20blue%20sky%20and%20amber%20harbor%20lights%20reflected%20on%20dark%20water%2C%20thick%20atmospheric%20fog%20and%20light%20rays%2C%20film%20noir%20mood%2C%20ultra%20wide%20composition%20with%20empty%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20people%20facing%20camera%2C%20no%20text&width=1600&height=900&seq=v91-hero-night-tide&orientation=landscape",
    tagline: '潮水退去，真相浮出',
    summary: '一桩被海水掩埋十年的旧案，因一次意外打捞重新浮出水面，刑警与记者携手追查。',
    synopsis: '临海小城的老码头在扩建时打捞出一只生锈的行李箱，里面藏着十年前的证物。刑警林澈被调回故乡任交接案，与坚持调查旧案的独立记者沈一舟意外结成同盟。随着潮汐记录、渔港账本与几段模糊的监控画面被逐一拼合，当年被刻意抹去的那一晚开始重现。两个人在追查真相的过程中，也逐渐直面各自与这座港口城市之间的旧伤。',
    cast: ['沈墨舟', '江晚宁', '程知远', '罗亦然'],
    director: '唐叙白',
    tags: ['悬疑', '犯罪', '双线叙事', '港城'],
  },
  {
    id: 'third-avenue',
    title: '第三大道',
    type: 'movie',
    genre: '剧情',
    region: '美国',
    year: 2024,
    episodes: '141 分钟',
    rating: 8.4,
    views: 963000,
    updatedAt: '2025-09-12',
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20deserted%20rainy%20city%20avenue%20at%20dusk%20with%20warm%20streetlights%20and%20long%20shadows%2C%20muted%20slate%20blue%20and%20burnt%20orange%20color%20palette%2C%20reflective%20wet%20asphalt%2C%20moody%20urban%20noir%20photography%2C%20minimalist%20framing%2C%20no%20text&width=600&height=900&seq=v91-poster-third-avenue&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20city%20avenue%20at%20blue%20hour%20with%20rain-slicked%20streets%20and%20warm%20orange%20lamplight%20glow%2C%20tall%20buildings%20fading%20into%20mist%2C%20dark%20navy%20sky%2C%20lonely%20urban%20atmosphere%2C%20editorial%20film%20still%20aesthetic%2C%20large%20dark%20negative%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-third-avenue&orientation=landscape",
    tagline: '每条街都有自己的故事',
    summary: '一名开了三十年出租车的司机，用一个个夜晚的乘客，串起一座城市的悲欢。',
    synopsis: '从黄昏到天亮，出租车司机约瑟夫在第三大道上来回穿行。他载过刚被解雇的舞台剧演员、赶着去见母亲最后一面的护士、对整座城市发火的年轻程序员，也载过十年前的老乘客。看似互不相干的夜晚被一张旧名片轻轻连起，最终在黎明的十字路口，他做出了一个迟到许久的决定。',
    cast: ['艾略特·坎贝尔', '玛丽安娜·霍尔', '托马斯·雷恩'],
    director: 'N. 卡尔森',
    tags: ['剧情', '城市', '人生', '温情'],
  },
  {
    id: 'iron-whistle',
    title: '铁哨长空',
    type: 'movie',
    genre: '动作',
    region: '中国大陆',
    year: 2025,
    episodes: '132 分钟',
    rating: 8.1,
    views: 2140000,
    updatedAt: '2025-10-05',
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20artwork%20of%20fighter%20jet%20silhouette%20against%20stormy%20dusk%20sky%20with%20burning%20orange%20clouds%20and%20dark%20navy%20storm%20clouds%2C%20dramatic%20backlit%20composition%2C%20high%20contrast%20cinematic%20photography%2C%20minimal%20modern%20poster%20style%2C%20no%20text&width=600&height=900&seq=v91-poster-iron-whistle&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20sky%20scene%20above%20clouds%20at%20sunset%20with%20orange%20light%20and%20dark%20navy%20cloud%20masses%2C%20distant%20jet%20trail%20streaking%20across%20sky%2C%20dramatic%20atmospheric%20depth%2C%20epic%20film%20still%20look%2C%20large%20dark%20empty%20area%20on%20the%20left%20for%20title%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-iron-whistle&orientation=landscape",
    tagline: '一声哨响，向天而行',
    summary: '退役飞行员重返试飞队，用一次危险任务证明：真正的极限从来不在仪表上。',
    synopsis: '五年前的一场空中事故让试飞员陆铮离开了一线。当新型验证机进入最关键的失速改出试验，整个队伍陷入僵局，他被临时召回担任试飞顾问。旧搭档的质疑、家人的反对和自己未愈的耳疾，都成了他回到驾驶舱前必须跨过的门槛。当他再一次听到地面上那声熟悉的铁哨，属于他的航程才真正开始。',
    cast: ['陆铮影', '许岸川', '白露晞', '黎岸'],
    director: '严与川',
    tags: ['动作', '航空', '热血', '逆袭'],
  },
  {
    id: 'glass-greenhouse',
    title: '玻璃温室',
    type: 'movie',
    genre: '爱情',
    region: '日本',
    year: 2023,
    episodes: '118 分钟',
    rating: 8.6,
    views: 742000,
    updatedAt: '2025-08-20',
    poster: "https://readdy.ai/api/search-image?query=Delicate%20cinematic%20movie%20poster%20artwork%20of%20a%20glass%20greenhouse%20filled%20with%20white%20flowers%20at%20soft%20dusk%2C%20misty%20glass%20panes%20and%20warm%20orange%20lantern%20glow%2C%20cool%20navy%20blue%20evening%20light%20outside%2C%20gentle%20romantic%20atmosphere%2C%20fine%20art%20photography%2C%20no%20text&width=600&height=900&seq=v91-poster-glass-greenhouse&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20scene%20of%20a%20large%20glass%20greenhouse%20at%20twilight%20surrounded%20by%20misty%20fields%2C%20warm%20orange%20interior%20lantern%20glow%20against%20deep%20navy%20blue%20dusk%20sky%2C%20soft%20rain%20streaks%20on%20glass%2C%20dreamy%20romantic%20film%20still%20aesthetic%2C%20dark%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-glass-greenhouse&orientation=landscape",
    tagline: '有些花开，只为等一个人',
    summary: '植物学研究员与花店老板在一个将被拆除的温室相识，用一个夏天交换彼此的四季。',
    synopsis: '城南的老温室即将被改建成停车场，植物学研究员七海被派来做最后的物种记录。她遇到了在这里经营了三年花店的青年匠海，两个人从互相看不顺眼，到共同抢救温室里的最后一批银叶兰。夏天结束时，这间玻璃房子没能保住，但他们各自生命里的季节，悄悄换了一轮。',
    cast: ['柳川千夏', '秋庭圭', '早坂瑞希'],
    director: '井上逢',
    tags: ['爱情', '治愈', '夏日', '温柔'],
  },
  {
    id: 'sand-clock',
    title: '沙漏之外',
    type: 'movie',
    genre: '科幻',
    region: '英国',
    year: 2024,
    episodes: '137 分钟',
    rating: 8.3,
    views: 1086000,
    updatedAt: '2025-09-02',
    poster: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20artwork%20of%20a%20glowing%20hourglass%20floating%20in%20dark%20space%20with%20particles%20of%20ember%20orange%20light%2C%20deep%20navy%20and%20ink%20black%20background%20with%20subtle%20blue%20nebula%2C%20minimal%20elegant%20scientific%20aesthetic%2C%20cinematic%20high%20contrast%2C%20no%20text&width=600&height=900&seq=v91-poster-sand-clock&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20sci-fi%20scene%20of%20a%20vast%20abandoned%20observatory%20dome%20under%20a%20starry%20deep%20navy%20sky%2C%20amber%20instrument%20glow%20inside%2C%20floating%20dust%20particles%20and%20time%20ripple%20light%20effects%2C%20epic%20atmospheric%20scale%2C%20dark%20negative%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-sand-clock&orientation=landscape",
    tagline: '时间不是线，是一个环',
    summary: '物理学家发现每一次入睡都会多出一小时，而这一小时正被某种力量悄悄回收。',
    synopsis: '在北大西洋的一座废弃观测站里，物理学家艾米丽·格雷在研究中发现一个反常的数据缺口：她每天醒来都比闹钟早了整整一小时，而所有记录设备都显示时间线正常。当她开始追踪这段"多余的时间"，她遇见了同样在寻找答案的钟表修复师，以及一位坚持认为时间是被"借走"的老教授。三个人逐渐拼出一个令人不安的结论：这座城市正在为某个未来偿还利息。',
    cast: ['艾米丽·格雷', '鲁本·斯奈德', '海伦·奥朗'],
    director: 'D. 维克斯',
    tags: ['科幻', '悬疑', '时间循环', '烧脑'],
  },
  {
    id: 'little-city-thief',
    title: '小城大盗',
    type: 'movie',
    genre: '喜剧',
    region: '中国香港',
    year: 2023,
    episodes: '105 分钟',
    rating: 7.9,
    views: 655000,
    updatedAt: '2025-07-18',
    poster: "https://readdy.ai/api/search-image?query=Playful%20cinematic%20comedy%20movie%20poster%20artwork%20of%20a%20retro%20neon-lit%20small%20city%20street%20at%20night%20with%20orange%20signage%20reflections%20on%20wet%20pavement%2C%20deep%20navy%20shadows%2C%20quirky%20vintage%20film%20color%20grading%2C%20empty%20street%20scene%2C%20no%20text&width=600&height=900&seq=v91-poster-little-city-thief&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20retro%20small%20town%20street%20at%20night%20with%20glowing%20orange%20neon%20shop%20signs%20and%20deep%20navy%20blue%20shadows%2C%20wet%20reflective%20road%2C%20quirky%20nostalgic%20film%20still%20aesthetic%2C%20atmospheric%20warm%20and%20cool%20color%20contrast%2C%20dark%20empty%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-little-city-thief&orientation=landscape",
    tagline: '偷走一座城，只为还一个人情',
    summary: '三个一事无成的年轻人计划偷走小城唯一的名画，结果连车都偷错了。',
    synopsis: '小城美术馆要办一场十年一遇的展览，三个过得不太顺利的老友决定把握"人生最后一次机会"。他们花了三个月研究路线，却把博物馆的营业时间记错了一天，偷走的还是一件高仿复制品。一场关于真伪、友情和小城体面的闹剧，就这样从错误的夜晚开始，一路荒唐到天亮。',
    cast: ['周小满', '陈皮仔', '阿棠', '郑一鸣'],
    director: '何启南',
    tags: ['喜剧', '犯罪', '友情', '小人物'],
  },
  {
    id: 'deep-sea-signal',
    title: '深海信号',
    type: 'movie',
    genre: '悬疑',
    region: '韩国',
    year: 2025,
    episodes: '126 分钟',
    rating: 8.5,
    views: 1473000,
    updatedAt: '2025-10-11',
    poster: "https://readdy.ai/api/search-image?query=Thriller%20movie%20poster%20artwork%20of%20a%20deep%20sea%20research%20submersible%20lights%20glowing%20in%20impenetrable%20dark%20ocean%2C%20faint%20amber%20beam%20cutting%20through%20navy%20blue%20water%20with%20floating%20particles%2C%20claustrophobic%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=v91-poster-deep-sea-signal&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20underwater%20scene%20of%20a%20deep%20sea%20research%20submersible%20with%20glowing%20amber%20lights%20in%20dark%20navy%20abyss%2C%20particles%20and%20light%20beams%20in%20water%2C%20eerie%20suspenseful%20atmosphere%2C%20dark%20open%20water%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-deep-sea-signal&orientation=landscape",
    tagline: '海底的信号，来自不该存在的地方',
    summary: '一支深海考察队在下潜三千米后收到规律的敲击声，而这声音来自失踪了八年的前一支队伍。',
    synopsis: '深海考察船"北纬七号"接到一项常规声呐普查任务。下潜至三千米时，队员们在噪音中识别出一段高度规律的人工敲击信号，频率与八年前失联的"经纬号"完全一致。究竟是设备串扰，还是有人还留在下面？随着氧气余额减少，队内关于"是否返航"的分歧也一点点撕开，每个人都在隐瞒一些关于那支旧队伍的事。',
    cast: ['韩道允', '徐允真', '白承河', '李泰悟'],
    director: '朴載勋',
    tags: ['悬疑', '深海', '惊悚', '群像'],
  },
  {
    id: 'long-river-south',
    title: '长河向南',
    type: 'tv',
    genre: '古装',
    region: '中国大陆',
    year: 2025,
    episodes: '全 40 集',
    rating: 8.8,
    views: 3260000,
    updatedAt: '2025-10-15',
    poster: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20artwork%20of%20ancient%20river%20town%2C%20misty%20water%20and%20wooden%20bridges%20with%20warm%20lantern%20lights%2C%20deep%20navy%20blue%20night%20sky%20and%20subtle%20orange%20glow%2C%20elegant%20minimalist%20oriental%20painting%20style%2C%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=v91-poster-long-river-south&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20ancient%20Chinese%20river%20town%20at%20dusk%20with%20mist%20over%20water%2C%20wooden%20bridges%20and%20tiled%20rooftops%2C%20warm%20orange%20lantern%20glow%20against%20deep%20navy%20blue%20mountains%2C%20ink%20painting%20aesthetic%20film%20still%2C%20dark%20empty%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-long-river-south&orientation=landscape",
    tagline: '一河灯火，半部山河',
    summary: '漕运世家最不受宠的女儿，用一条船撑起半个王朝的粮道。',
    synopsis: '大晟年间，漕运总督府的三小姐沈知微被家族视作不祥之人，自小养在江尾的旧宅。一场突如其来的水患让整条漕路断绝，家中长子受诬下狱，她带着一支只剩七条船的残缺船队逆流北上。从江口的小码头到京畿的粮仓，她一步步把被吞掉的旧账算清，也把这座摇摇欲坠的王朝，勉强撑回了岸边。',
    cast: ['沈知微', '裴敬之', '苏南音', '陆宏舟'],
    director: '顾清和',
    tags: ['古装', '权谋', '大女主', '群像'],
  },
  {
    id: 'marriage-of-convenience',
    title: '合约夫妻',
    type: 'tv',
    genre: '都市',
    region: '中国大陆',
    year: 2024,
    episodes: '全 32 集',
    rating: 8.0,
    views: 2480000,
    updatedAt: '2025-09-25',
    poster: "https://readdy.ai/api/search-image?query=Modern%20romance%20drama%20poster%20artwork%20of%20a%20bright%20minimalist%20living%20room%20with%20warm%20afternoon%20sunlight%2C%20two%20empty%20mugs%20and%20a%20single%20houseplant%20on%20a%20wooden%20table%2C%20soft%20cream%20and%20navy%20accents%20with%20orange%20detail%2C%20clean%20editorial%20aesthetic%2C%20no%20text&width=600&height=900&seq=v91-poster-marriage-convenience&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20modern%20apartment%20living%20room%20at%20golden%20hour%20with%20soft%20cream%20walls%2C%20deep%20navy%20accents%20and%20warm%20orange%20sunlight%20spilling%20across%20wooden%20floors%2C%20minimalist%20styling%2C%20warm%20cozy%20editorial%20film%20still%2C%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-marriage-convenience&orientation=landscape",
    tagline: '合同三年，心动怎么算',
    summary: '两个被房贷和亲戚逼到头大的年轻人签下三年合约，把日子过成了一场精打细算的合作。',
    synopsis: '林见夏是广告公司的创意组长，接到最大客户的前一天丢了住所；周砚是独立设计师，最大的问题是家里三年内必须"有着落"。两个人在一场房屋中介的乌龙里认识，用一周时间完成了见家长、拍婚纱照、搬家全过程。合约写得清清楚楚：三年为限，互不干涉，费用分摊。可生活从来不是一份合同能管住的事。',
    cast: ['林见夏', '周砚之', '许芷宁', '江桓'],
    director: '余柚',
    tags: ['都市', '情感', '同居', '轻喜'],
  },
  {
    id: 'cold-case-file',
    title: '迷案档案',
    type: 'tv',
    genre: '悬疑',
    region: '英国',
    year: 2024,
    episodes: '第 1–12 集',
    rating: 8.9,
    views: 1920000,
    updatedAt: '2025-10-08',
    poster: "https://readdy.ai/api/search-image?query=Crime%20drama%20poster%20artwork%20of%20a%20stack%20of%20old%20paper%20case%20files%20on%20a%20wooden%20desk%20under%20a%20single%20warm%20desk%20lamp%2C%20deep%20navy%20blue%20shadows%2C%20aged%20paper%20texture%2C%20moody%20detective%20aesthetic%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=v91-poster-cold-case-file&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20dim%20detective%20office%20with%20stacks%20of%20old%20case%20files%2C%20green%20and%20navy%20blue%20shadows%20with%20warm%20orange%20desk%20lamp%20glow%2C%20dusty%20air%20and%20rainy%20window%2C%20moody%20prestige%20drama%20still%2C%20empty%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-cold-case-file&orientation=landscape",
    tagline: '每个档案背后，都有一个没说完的人',
    summary: '一个被解散的旧案组，一间堆满灰尘的资料室，十二个被时间盖住名字的案子。',
    synopsis: '因为一起找不到证据的失踪案被媒体推上风口浪尖，警方决定解散原专案组。档案管理员出身的警员艾薇·布莱克被留下负责整理那些永远没有结论的旧卷宗。她很快发现，这些看似无关的案件之间，反复出现同一串电话号码和同一份值班表。在没有任何人支持的条件下，她重新开始逐条走访，让时间替那些沉默的人说话。',
    cast: ['艾薇·布莱克', '亨利·沃斯', '克拉拉·艾登'],
    director: 'J. 麦修道',
    tags: ['悬疑', '犯罪', '单元剧', '推理'],
  },
  {
    id: 'war-of-dawn',
    title: '晨曦之战',
    type: 'tv',
    genre: '战争',
    region: '中国大陆',
    year: 2023,
    episodes: '全 36 集',
    rating: 8.2,
    views: 1330000,
    updatedAt: '2025-06-30',
    poster: "https://readdy.ai/api/search-image?query=War%20drama%20poster%20artwork%20of%20a%20mountain%20ridge%20silhouette%20at%20first%20light%20with%20dense%20fog%20and%20burning%20orange%20sun%20behind%20deep%20navy%20blue%20hills%2C%20textured%20grain%20film%20poster%20style%2C%20solemn%20epic%20atmosphere%2C%20no%20text&width=600&height=900&seq=v91-poster-war-dawn&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20mountain%20ridge%20at%20dawn%20with%20heavy%20fog%20and%20warm%20orange%20sunrise%20glow%20breaking%20through%20deep%20navy%20blue%20peaks%2C%20solemn%20epic%20historical%20war%20film%20still%2C%20textured%20atmosphere%2C%20large%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-war-dawn&orientation=landscape",
    tagline: '天还没亮，先走的人最冷',
    summary: '一支通信班在断线七天的山谷里，用一台旧电台把整支部队的坐标送了出去。',
    synopsis: '一九三八年秋，一支只有九个人的通信班被派往后山架设中继站。当敌军合围、主力与外界断联时，他们手上的最后一条线路，成了唯一能把部队坐标送出的通道。从天黑到天亮，九个原本互不相识的人用各自的方式守住了那台电台，也守住了山谷里所有还在等待消息的人。',
    cast: ['秦北川', '聂秋生', '岑妍', '江弘毅'],
    director: '卫南风',
    tags: ['战争', '群像', '信仰', '历史'],
  },
  {
    id: 'war-of-hearts',
    title: '都市心跳',
    type: 'tv',
    genre: '职场',
    region: '中国大陆',
    year: 2025,
    episodes: '全 28 集',
    rating: 7.8,
    views: 1180000,
    updatedAt: '2025-09-18',
    poster: "https://readdy.ai/api/search-image?query=Modern%20workplace%20drama%20poster%20artwork%20of%20a%20glass%20office%20tower%20at%20blue%20hour%20reflected%20in%20a%20calm%20city%20river%2C%20warm%20orange%20window%20lights%20dotting%20the%20facade%2C%20deep%20navy%20blue%20tones%2C%20clean%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=v91-poster-urban-heartbeat&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20city%20skyline%20at%20blue%20hour%20seen%20across%20a%20calm%20river%2C%20glass%20office%20towers%20with%20warm%20orange%20window%20lights%2C%20deep%20navy%20blue%20sky%20and%20soft%20mist%2C%20polished%20modern%20editorial%20film%20still%2C%20empty%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-urban-heartbeat&orientation=landscape",
    tagline: '在这座城市，心跳也要排期',
    summary: '急诊科新来的主治医生发现，真正难救的不是病，是这套被排到分秒的系统。',
    synopsis: '年轻的主治医生温以宁被调往全市最繁忙的急诊中心，第一周就遇上了一场连环事故。她在抢救室里认识了不苟言笑的科室主任，也撞见了被数据指标压得喘不过气的同事们。一边是必须守住的医疗底线，一边是永无止境的排期表，她开始学着在两者之间找到那条窄得几乎看不见的路。',
    cast: ['温以宁', '祁斯远', '娄清', '秦朗'],
    director: '裴书言',
    tags: ['职场', '医疗', '都市', '成长'],
  },
  {
    id: 'spring-new-moon',
    title: '春风不问',
    type: 'tv',
    genre: '古装',
    region: '中国大陆',
    year: 2024,
    episodes: '全 40 集',
    rating: 8.4,
    views: 2760000,
    updatedAt: '2025-09-06',
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%20artwork%20of%20a%20red%20lantern%20beside%20a%20moonlit%20courtyard%20wall%2C%20plum%20branches%20in%20soft%20focus%2C%20deep%20navy%20blue%20night%20sky%20with%20a%20warm%20amber%20glow%2C%20elegant%20minimal%20oriental%20aesthetic%2C%20no%20text&width=600&height=900&seq=v91-poster-spring-moon&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20imperial%20palace%20courtyard%20at%20night%20with%20moonlight%20on%20white%20walls%20and%20plum%20branches%2C%20warm%20orange%20lantern%20light%20and%20deep%20navy%20blue%20sky%2C%20mist%20on%20stone%20paths%2C%20elegant%20oriental%20film%20still%20aesthetic%2C%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-spring-moon&orientation=landscape",
    tagline: '春风一到，旧事都醒了',
    summary: '女史官为一部旧史翻案，却在字里行间发现自己的名字早已被人写进了结局。',
    synopsis: '大历年间，女史官苏问春在整理前朝实录时，发现一卷被换过的残本。为了弄清其中一段被删去的记载，她不得不与朝中最不受欢迎的谏官联手。两个人从一部史书查到一座旧宅，从一份奏章追到一场从未被记录的大火，也逐渐发现：自己正在书写的这本史书，早就有人替他们写好了结尾。',
    cast: ['苏问春', '谢无咎', '温太傅', '林照'],
    director: '俞见微',
    tags: ['古装', '爱情', '探案', '朝堂'],
  },
  {
    id: 'city-of-lights',
    title: '灯火之城',
    type: 'tv',
    genre: '家庭',
    region: '中国台湾',
    year: 2023,
    episodes: '全 24 集',
    rating: 8.6,
    views: 890000,
    updatedAt: '2025-07-02',
    poster: "https://readdy.ai/api/search-image?query=Family%20drama%20poster%20artwork%20of%20a%20small%20neighborhood%20street%20at%20night%20with%20warm%20orange%20hanging%20lanterns%20and%20glowing%20shopfronts%2C%20deep%20navy%20blue%20dusk%20sky%2C%20nostalgic%20gentle%20atmosphere%2C%20warm%20editorial%20film%20photography%2C%20no%20text&width=600&height=900&seq=v91-poster-city-of-lights&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20narrow%20old%20neighborhood%20street%20at%20dusk%20with%20warm%20orange%20hanging%20lanterns%20and%20glowing%20shop%20windows%2C%20deep%20navy%20blue%20evening%20sky%2C%20nostalgic%20warm%20film%20still%20with%20soft%20bokeh%2C%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-city-of-lights&orientation=landscape",
    tagline: '这条街，记得每一个回家的人',
    summary: '一条即将拆迁的老街，十二户人家，一整年的灯火与告别。',
    synopsis: '老街要拆了的消息在春天传开。经营了四十年面摊的陈阿姨、刚考上大学的阿杰、准备关店回乡的钟表师傅，还有每天都来街口下棋的几位老人家，各自在心里打算着往后的去处。一年时间里，这条街办了婚礼、送走了老人、也迎来了第一个在这里出生的孩子，最后在冬天点亮了最后一次灯。',
    cast: ['陈秀兰', '阿杰', '钟老师', '吴伯'],
    director: '简云青',
    tags: ['家庭', '温情', '群像', '时代'],
  },
  {
    id: 'island-duel',
    title: '海岛对决',
    type: 'tv',
    genre: '青春',
    region: '韩国',
    year: 2025,
    episodes: '全 16 集',
    rating: 8.1,
    views: 1590000,
    updatedAt: '2025-10-01',
    poster: "https://readdy.ai/api/search-image?query=Youth%20drama%20poster%20artwork%20of%20a%20rocky%20island%20coastline%20at%20sunset%20with%20warm%20orange%20sky%20and%20deep%20navy%20blue%20sea%2C%20breaking%20waves%20and%20lighthouse%20silhouette%2C%20energetic%20cinematic%20composition%2C%20clean%20minimal%20layout%2C%20no%20text&width=600&height=900&seq=v91-poster-island-duel&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20rocky%20island%20coast%20at%20sunset%20with%20warm%20orange%20sky%20and%20deep%20navy%20blue%20sea%2C%20waves%20crashing%20on%20cliffs%20and%20distant%20lighthouse%2C%20vibrant%20youthful%20film%20still%2C%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-island-duel&orientation=landscape",
    tagline: '输赢之外，还有我们一起走过的海',
    summary: '两个被退队的少年在一次海岛特训里重新认识彼此，也重新认识自己。',
    synopsis: '竞技帆船队的两名主力因为一次赛场冲突同时被退队。学校把他们送去海岛参加一场为期八周的特训营，条件是必须一起完成所有项目。从拆船、修桅杆到一起熬夜看潮汐表，两个脾气完全不合的人被迫成为搭档。当特训营最后的比赛来临，他们终于明白，真正的对手从来不是对方。',
    cast: ['姜河俊', '李瑞安', '崔都贤'],
    director: '吴宥莉',
    tags: ['青春', '运动', '成长', '友情'],
  },
  {
    id: 'saturday-live-house',
    title: '周末喜剧场',
    type: 'variety',
    genre: '脱口秀',
    region: '中国大陆',
    year: 2025,
    episodes: '第 1–14 期',
    rating: 8.5,
    views: 2240000,
    updatedAt: '2025-10-16',
    poster: "https://readdy.ai/api/search-image?query=Comedy%20show%20poster%20artwork%20of%20an%20empty%20stage%20with%20a%20single%20microphone%20stand%20and%20warm%20orange%20spotlight%20beam%20cutting%20through%20deep%20navy%20blue%20smoke%2C%20dark%20theatre%20background%2C%20minimal%20bold%20poster%20composition%2C%20no%20text&width=600&height=900&seq=v91-poster-saturday-live&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20comedy%20club%20stage%20with%20warm%20orange%20spotlight%20cutting%20through%20deep%20navy%20blue%20haze%2C%20empty%20theatre%20seats%20in%20shadow%2C%20single%20microphone%20stand%20in%20center%20distance%2C%20dramatic%20stage%20lighting%2C%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-saturday-live&orientation=landscape",
    tagline: '一周的笑，都在周六还给你',
    summary: '每周六晚，一群把生活讲成段子的人，把三十平米的舞台讲成了整座城市的解压阀。',
    synopsis: '这是一档以线下小剧场为舞台的周播喜剧节目。每期邀请六位不同背景的表演者，讲述自己这一周遇见的荒诞日常：加班的第七天、被高德带错的相亲现场、以及永远在响的家族群。没有剧本、没有提词器，只有一支麦和一个愿意笑的观众席。',
    cast: ['主持人：雷小满', '常驻：阿肆', '常驻：汤圆', '常驻：老秦'],
    director: '周六小剧场制作组',
    tags: ['脱口秀', '喜剧', '生活', '周播'],
  },
  {
    id: 'slow-life-weekend',
    title: '慢慢来，周末',
    type: 'variety',
    genre: '生活',
    region: '中国大陆',
    year: 2024,
    episodes: '第 1–12 期',
    rating: 8.9,
    views: 1780000,
    updatedAt: '2025-09-14',
    poster: "https://readdy.ai/api/search-image?query=Slow%20living%20variety%20show%20poster%20artwork%20of%20a%20cozy%20wooden%20cabin%20porch%20with%20warm%20afternoon%20sunlight%2C%20a%20kettle%20and%20woven%20blanket%20on%20a%20stool%2C%20green%20mountains%20in%20soft%20haze%2C%20calm%20warm%20orange%20and%20navy%20accents%2C%20no%20text&width=600&height=900&seq=v91-poster-slow-weekend&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20mountain%20valley%20at%20golden%20hour%20with%20a%20small%20wooden%20cabin%2C%20mist%20over%20green%20rice%20terraces%2C%20warm%20orange%20sunlight%20and%20deep%20navy%20blue%20mountain%20haze%2C%20peaceful%20slow%20living%20aesthetic%2C%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-slow-weekend&orientation=landscape",
    tagline: '什么都不做，也是一种本事',
    summary: '六位嘉宾住进山谷里的小院，七天不接工作电话，只负责好好吃饭和晒太阳。',
    synopsis: '节目组把嘉宾们带到一座只有八户人家的山间小院，没收了所有工作手机。七天里没有任务、没有竞争，只有每天的三顿饭、一次散步和晚上的一场闲聊。从最初的手足无措到后来主动去帮村民收谷子，这档节目的主角最后不再是人，而是时间本身。',
    cast: ['常驻：秦阿姨', '常驻：小满', '嘉宾轮换'],
    director: '山谷慢生活工作室',
    tags: ['生活', '慢综艺', '治愈', '美食'],
  },
  {
    id: 'voice-of-stars',
    title: '星声计划',
    type: 'variety',
    genre: '音乐',
    region: '中国大陆',
    year: 2025,
    episodes: '第 1–16 期',
    rating: 8.3,
    views: 2650000,
    updatedAt: '2025-10-12',
    poster: "https://readdy.ai/api/search-image?query=Music%20competition%20poster%20artwork%20of%20a%20dark%20concert%20stage%20with%20warm%20orange%20and%20amber%20light%20beams%20and%20floating%20dust%2C%20deep%20navy%20blue%20haze%2C%20abstract%20soundwave%20light%20trails%2C%20dramatic%20minimal%20poster%20layout%2C%20no%20text&width=600&height=900&seq=v91-poster-voice-stars&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20concert%20arena%20stage%20with%20warm%20orange%20light%20beams%20and%20deep%20navy%20blue%20haze%2C%20abstract%20soundwave%20light%20trails%20in%20air%2C%20empty%20stage%20before%20performance%2C%20dramatic%20atmospheric%20scale%2C%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-voice-stars&orientation=landscape",
    tagline: '每一把声音，都值得一盏灯',
    summary: '素人歌手盲选登台，只用声音换一盏亮起的灯。',
    synopsis: '节目不设外形评审，也不看履历。每位登台者都在幕布后进行演唱，只有声音被听见。四位音乐制作人以"亮灯"表达邀请，全亮则开启抢人环节。从地下通道的驻唱到县城婚礼的歌手，这些被生活按下暂停的声音，在这一季里重新被听见。',
    cast: ['音乐总监：陈岸', '制作人：罗一宁', '制作人：高于野'],
    director: '星声节目组',
    tags: ['音乐', '竞演', '素人', '舞台'],
  },
  {
    id: 'kitchen-battle',
    title: '厨房擂台',
    type: 'variety',
    genre: '竞技',
    region: '中国大陆',
    year: 2025,
    episodes: '第 1–20 期',
    rating: 8.0,
    views: 1490000,
    updatedAt: '2025-10-04',
    poster: "https://readdy.ai/api/search-image?query=Cooking%20competition%20poster%20artwork%20of%20a%20dark%20professional%20kitchen%20pass%20with%20warm%20orange%20steam%20and%20flame%20light%2C%20steel%20pans%20and%20herbs%2C%20deep%20navy%20blue%20shadows%2C%20dramatic%20food%20photography%20aesthetic%2C%20no%20text&width=600&height=900&seq=v91-poster-kitchen-battle&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20professional%20kitchen%20with%20warm%20orange%20flame%20and%20steam%20against%20deep%20navy%20blue%20shadows%2C%20copper%20pans%20on%20hanging%20racks%2C%20empty%20competition%20stations%2C%20dramatic%20culinary%20film%20still%2C%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-kitchen-battle&orientation=landscape",
    tagline: '一口锅，见真章',
    summary: '二十位民间厨师，用一道家常菜打完整季擂台。',
    synopsis: '节目把舞台设在一座旧厂房改造的开放式厨房。每期一道主题，从"一碗蛋炒饭"到"妈妈的拿手菜"，选手只能用有限的食材和一台灶台作答。评审不看出身与名气，只凭入口的第一秒做判断。真正被端上台面的，其实是一道道关于家的记忆。',
    cast: ['主厨评审：蔡师傅', '主厨评审：余人可', '主持人：王一禾'],
    director: '厨房擂台节目组',
    tags: ['竞技', '美食', '素人', '厨艺'],
  },
  {
    id: 'real-talk-room',
    title: '真话小屋',
    type: 'variety',
    genre: '访谈',
    region: '中国香港',
    year: 2024,
    episodes: '第 1–10 期',
    rating: 8.7,
    views: 1120000,
    updatedAt: '2025-08-08',
    poster: "https://readdy.ai/api/search-image?query=Intimate%20talk%20show%20poster%20artwork%20of%20a%20small%20dark%20studio%20with%20two%20warm%20orange%20lamps%20and%20a%20pair%20of%20armchairs%20facing%20each%20other%2C%20deep%20navy%20blue%20walls%2C%20soft%20shadow%20mood%2C%20minimal%20elegant%20framing%2C%20no%20text&width=600&height=900&seq=v91-poster-real-talk&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20dark%20intimate%20talk%20studio%20with%20two%20warm%20orange%20floor%20lamps%20and%20empty%20armchairs%2C%20deep%20navy%20blue%20walls%20with%20soft%20shadow%20texture%2C%20quiet%20cinematic%20mood%2C%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-real-talk&orientation=landscape",
    tagline: '一间小屋，一个问题，一个晚上',
    summary: '每期一个人，一个问题，聊到灯光自动熄灭为止。',
    synopsis: '演播室被设计成一间只有两把椅子的小房间，灯光由计时器控制，聊到时间结束会自动熄灭。没有预设问题卡，也没有观众，主持人只负责听。有人聊了职业转型，有人聊了一家人都不知道的事，也有一次，只安静地坐了二十七分钟。',
    cast: ['主持人：麦念之'],
    director: '真话工作室',
    tags: ['访谈', '深度', '人文', '慢节奏'],
  },
  {
    id: 'snow-mountain-road',
    title: '雪山公路',
    type: 'movie',
    genre: '剧情',
    region: '中国大陆',
    year: 2024,
    episodes: '115 分钟',
    rating: 8.5,
    views: 810000,
    updatedAt: '2025-09-20',
    poster: "https://readdy.ai/api/search-image?query=Road%20movie%20poster%20artwork%20of%20a%20lonely%20winding%20mountain%20road%20through%20snow%2C%20warm%20orange%20headlights%20glow%20in%20deep%20navy%20blue%20dusk%2C%20majestic%20snow%20peaks%20in%20mist%2C%20cinematic%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=v91-poster-snow-road&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20snow%20covered%20mountain%20highway%20at%20dusk%20with%20warm%20orange%20headlights%20glow%2C%20deep%20navy%20blue%20dusk%20sky%20and%20misty%20peaks%2C%20solitary%20atmosphere%2C%20cinematic%20wide%20angle%20film%20still%2C%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-snow-road&orientation=landscape",
    tagline: '一千公里的路，只为说一句对不起',
    summary: '一位父亲开着一辆旧货车，沿着女儿曾走过的路线，把没说完的话说完。',
    synopsis: '女儿离开家五年后，老周在她留下的笔记本里发现了一条横跨一千公里的路线。他开着那辆旧货车出发，沿路停在她曾住过的青旅、打过工的咖啡馆和写过字的天桥下。一路上他遇到的人，都比记忆里的女儿更具体，也让他终于明白，那场争吵里自己究竟错在哪里。',
    cast: ['周立平', '许桐', '马一丹'],
    director: '陶野',
    tags: ['剧情', '公路', '亲情', '治愈'],
  },
  {
    id: 'steel-heart',
    title: '钢铁之心',
    type: 'movie',
    genre: '动画',
    region: '日本',
    year: 2025,
    episodes: '109 分钟',
    rating: 8.2,
    views: 1230000,
    updatedAt: '2025-10-09',
    poster: "https://readdy.ai/api/search-image?query=Animated%20film%20poster%20artwork%20of%20a%20small%20friendly%20robot%20holding%20a%20glowing%20orange%20core%2C%20standing%20in%20a%20deep%20navy%20blue%20industrial%20city%20at%20night%2C%20painterly%20illuminated%20atmosphere%2C%20warm%20light%20against%20cool%20dark%20tones%2C%20no%20text&width=600&height=900&seq=v91-poster-steel-heart&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ultra%20wide%20animated%20film%20scene%20of%20a%20vast%20deep%20navy%20industrial%20city%20at%20night%20with%20warm%20orange%20lights%2C%20gentle%20mist%20and%20glowing%20windows%2C%20painterly%20hand-drawn%20style%20with%20soft%20volumetric%20light%2C%20dark%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-steel-heart&orientation=landscape",
    tagline: '它没有心，却学会了想念',
    summary: '一台维修用机器人在废墟里捡到一颗小小的能量核，决定把它送回城市另一头。',
    synopsis: '在已经停工多年的钢铁城，编号 VII-3 的维修机器人靠捡废料维持运转。一次常规清扫中，它在废弃机库里发现了一颗被遗忘的能量核，上面贴着一张写着地址的旧标签。为了把它送回去，它必须穿过封锁的街区、绕开巡逻的机械狗，并在途中第一次思考：为什么自己要为一件与程序无关的事，走这么远。',
    cast: ['配音：小野凉声', '配音：佐仓真', '配音：宫下启'],
    director: '动画：三本书房',
    tags: ['动画', '科幻', '机器', '温情'],
  },
  {
    id: 'rainy-day-notes',
    title: '雨天笔记',
    type: 'movie',
    genre: '爱情',
    region: '泰国',
    year: 2024,
    episodes: '112 分钟',
    rating: 8.0,
    views: 560000,
    updatedAt: '2025-08-14',
    poster: "https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20artwork%20of%20a%20rainy%20street%20cafe%20window%20with%20warm%20orange%20interior%20light%20and%20blue%20navy%20exterior%20dusk%2C%20water%20droplets%20on%20glass%20and%20an%20open%20notebook%20on%20a%20table%2C%20tender%20atmospheric%20film%20photography%2C%20no%20text&width=600&height=900&seq=v91-poster-rainy-notes&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20rainy%20city%20street%20at%20dusk%20with%20a%20warm%20orange%20lit%20cafe%20window%20and%20blue%20navy%20reflections%20on%20wet%20road%2C%20soft%20bokeh%20lights%2C%20romantic%20quiet%20film%20still%2C%20open%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=900&seq=v91-hero-rainy-notes&orientation=landscape",
    tagline: '雨停之前，我想把话说完',
    summary: '两个常常在同一家咖啡馆躲雨的人，用一本共享笔记交换了一整个雨季的心事。',
    synopsis: '曼谷的雨季绵长，一家转角咖啡馆里总有两个固定座位：靠窗的那个，和书架旁的那个。女孩在笔记本里留下一句抱怨天气的话，第二天发现有人在下面接了话。从此那本旧笔记成了他们的信箱，从天气聊到工作，从工作聊到不敢说出口的喜欢。直到雨季结束，他们才第一次真正见面。',
    cast: ['娜琳', '披拉', '苏查'],
    director: 'P. 塔纳蓬',
    tags: ['爱情', '雨季', '书信', '清新'],
  },
];